import { makeObservable, observable, action } from 'mobx';

class CounterStore {
  constructor() {
    makeObservable(this, {
      count: observable,
      increment: action,
      decrement: action,
    });
  }
  count = 0;
  increment() {
    this.count += 1;
    
  }
  decrement() {
    this.count -= 1;
  }
}

export default new CounterStore();
